// extracted by mini-css-extract-plugin
module.exports = {"productGrid":"Px-z","centerLink":"Qx-z","productSection":"Rx-z","item":"Sx-z","ctaButton":"Tx-z"};